/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetReportDefinitionByReportTypeQueryResponse, GetReportDefinitionByReportTypePathParams, GetReportDefinitionByReportTypeQueryParams, GetReportDefinitionByReportType400, GetReportDefinitionByReportType404 } from "../models/GetReportDefinitionByReportType";

export function getGetReportDefinitionByReportTypeUrl(reportType: GetReportDefinitionByReportTypePathParams["reportType"]) {
  const res = { method: 'GET', url: `/report-definitions/default/${reportType}` as const }
  return res
}

/**
 * @description Retrieves the default report definition for the specified report type. For the specified blueprint version (or latest if not provided), returns the default definition. If definitionId is provided, returns that specific definition instead. If no default definition exists, creates and saves a default one from the blueprint.
 * @summary Get default report definition
 * {@link /report-definitions/default/:reportType}
 */
export async function getReportDefinitionByReportType(reportType: GetReportDefinitionByReportTypePathParams["reportType"], params?: GetReportDefinitionByReportTypeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetReportDefinitionByReportTypeQueryResponse, ResponseErrorConfig<GetReportDefinitionByReportType400 | GetReportDefinitionByReportType404>, unknown>({ method : "GET", url : getGetReportDefinitionByReportTypeUrl(reportType).url.toString(), params, ... requestConfig })
  return res.data
}